import React from 'react';
import { View, } from 'react-native';
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs';

import CommonHeader from '../../../shared/commonComponents/commonHeader'
import { appColors, appFonts, fontSize } from '../../../themes/appTheme';

import Modifiers from './modifiers';

function ModifierScreen(): React.JSX.Element {
    const TopTab = createMaterialTopTabNavigator()
    return (
        <View style={{ flex: 1 }} >
            <CommonHeader headerName="Modifier" />
            <TopTab.Navigator
                initialRouteName="Modifier Options"
                screenOptions={{
                    tabBarLabelStyle: { fontSize: fontSize.largerFontSize, fontFamily: appFonts.bold, textTransform: 'capitalize' },
                    tabBarIndicatorStyle: { backgroundColor: appColors.primary },
                    tabBarActiveTintColor: appColors.primary,
                    tabBarInactiveTintColor: appColors.lightFontColor,
                    tabBarAndroidRipple: { borderless: false },
                }}
                backBehavior="none" >
                <TopTab.Screen
                    name="Modifier Options"
                    options={{ tabBarLabel: 'Modifier Options', title: "Modifier Options" }}
                    component={Modifiers}
                    initialParams={{ key: "options" }}
                />
                <TopTab.Screen
                    name="Modifier Set"
                    options={{ tabBarLabel: 'Modifier Set', title: "Modifier Set" }}
                    component={Modifiers}
                    initialParams={{ key: "set" }}
                />
            </TopTab.Navigator>

        </View >
    );
}

export default ModifierScreen;